export const techRegionPrice = {
  "US & Canada": {
    cohorts: ["tech-cohort1", "tech-cohort2"],
    payments: [
      {
        id: 1,
        price: 500, // USD price
        slashPrice: 625, // USD slashed price
        buttonLabel: "Enrol now",
        buttonUrl: "https://buy.stripe.com/cNidR8aaS6T49Ba9IW87K2R",
        description: [
          "➢ Join multiple projects within a year",
          "➢ Join an ongoing project right away",
          "➢ Join new client projects as they become available",
          "➢ Get work reference from reputable organizations",
          "➢ 1 month on-the-job support",
          "➢ Join project stand-up, retro, demo and scrum ceremonies",
          "➢ Receive feedback from seasoned mentors",
          "➢ Work in a cross-functional team"
        ].join('\n'),
        pillText: "25% OFF (Popular  Option)",
        type: "One time payment",
        defaultPrice: 699, // CAD price (25% higher than USD for demo purposes)
        href: "https://buy.stripe.com/cNidR8aaS6T49Ba9IW87K2R",
        href2: "#pay-us-2",
        href3: "#pay-us-3",
        defaultSlash: 870, // CAD slashed price
        symbol: "USD",
        toggledSymbol: "CAD"
      },
      {
        id: 2,
        price: 265,
        slashPrice: null,
        buttonLabel: "Pay in instalment",
        buttonUrl: "https://buy.stripe.com/6oUdR86YG91cdRq2gu87K2S",
        description: [
          "➢ Join multiple projects within a year",
          "➢ Join an ongoing project right away",
          "➢ Join new client projects as they become available",
          "➢ Get work reference from reputable organizations",
          "➢ 1 month on-the-job support",
          "➢ Join project stand-up, retro, demo and scrum ceremonies",
          "➢ Receive feedback from seasoned mentors",
          "➢ Work in a cross-functional team"
        ].join('\n'),
        pillText: "Flexible",
        type: "Two-time payment",
        defaultPrice: 364, // CAD price (25% higher than USD for demo purposes)
        href: "#pay-us-Two-time payment",
        defaultSlash: null, // CAD slashed price
        symbol: "USD",
        toggledSymbol: "CAD"
      }
    ]
  },
  "Europe - Africa": {
    cohorts: ["tech-cohort3", "tech-cohort4"],
    payments: [
      {
        id: 1,
        price: 400, // GBP price
        slashPrice: 500, // GBP slashed price
        buttonLabel: "Enrol now",
        buttonUrl: "https://buy.stripe.com/cNidR8aaS6T49Ba9IW87K2R",
        description: [
    
          "➢ Join multiple projects within a year",
          "➢ Join an ongoing project right away",
          "➢ Join new client projects as they become available",
          "➢ Get work reference from reputable organizations",
          "➢ 1 month on-the-job support",
          "➢ Join project stand-up, retro, demo and scrum ceremonies",
          "➢ Receive feedback from seasoned mentors",
          "➢ Work in a cross-functional team"
        ].join('\n'),
        pillText: "25% OFF (Popular  Option)",
        type: "One time payment",
        defaultPrice: 450, // Euro price (20% higher than GBP for demo purposes)
        href: "https://buy.stripe.com/cNidR8aaS6T49Ba9IW87K2R",
        href2: "#pay-eu-2",
        href3: "#pay-eu-3",
        defaultSlash: 565, // Euro slashed price
        symbol: "£",
        toggledSymbol: "€"
      },
      {
        id: 2,
        price: 210,
        slashPrice: null,
        buttonLabel: "Pay in instalment",
        buttonUrl: "https://buy.stripe.com/6oUdR86YG91cdRq2gu87K2S",
        description: [

          "➢ Join multiple projects within a year",
          "➢ Join an ongoing project right away",
          "➢ Join new client projects as they become available",
          "➢ Get work reference from reputable organizations",
          "➢ 1 month on-the-job support",
          "➢ Join project stand-up, retro, demo and scrum ceremonies",
          "➢ Receive feedback from seasoned mentors",
          "➢ Work in a cross-functional team"
        ].join('\n'),
        pillText: "Flexible",
        type: "Two-time payment",
        defaultPrice: 240, // Euro price (20% higher than GBP for demo purposes)
        href: "https://buy.stripe.com/6oUdR86YG91cdRq2gu87K2S",
        defaultSlash: null, // Euro slashed price
        symbol: "£",
        toggledSymbol: "€"
      }
    ]
  }
};

export const techFormDatas = {
  defaultRegion: "US & Canada" // Default region setting
};
